<template>
  <li>
    <label class="group relative block cursor-pointer">
      <input
        :checked="option.selected"
        class="absolute inset-0 opacity-0"
        :disabled="shouldDisplayDisabledState"
        :name="`step-${radioName || step.id}`"
        type="radio"
        :value="option.trackingValue"
        @keydown.enter="onClick"
      />
      <LargePicker
        :addon="option.addon"
        :best-deal
        :color="option.color"
        :contextual-callout
        :data-qa="dataQaAttribute"
        :disabled="shouldDisplayDisabledState"
        :index
        :is-small
        :label
        :label-highlight="option.highlight"
        :loading
        :prefix="option.style?.prefix"
        :price="description"
        :selected="option.selected"
        :sub-label
        :tag
        @click="onClick"
      />
    </label>
  </li>
</template>

<script lang="ts" setup>
import LargePicker from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/LargePicker/LargePicker.vue'
import { useStepOptionInteraction } from '~/scopes/product-core/components/presentationals/CustomizationFunnel/composables/useStepOptionInteraction/useStepOptionInteraction'
import type {
  CondensedOption,
  CondensedStep,
} from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/CustomizationFunnelCondensed.types'

const props = withDefaults(
  defineProps<{
    step: CondensedStep
    option: CondensedOption
    index: number
    isGroupLoading?: boolean
    isSmall?: boolean
    hideSoldOut?: boolean
    radioName?: string
    firstPickerId?: string
  }>(),
  {
    isGroupLoading: false,
    isSmall: false,
    hideSoldOut: false,
    radioName: '',
    firstPickerId: '',
  },
)

const emit = defineEmits<{
  click: [CondensedOption, CondensedStep]
  changed: [CondensedOption, CondensedStep]
}>()

const {
  loading,
  description,
  label,
  subLabel,
  tag,
  shouldDisplayDisabledState,
  bestDeal,
  contextualCallout,
  dataQaAttribute,
  onClick,
} = useStepOptionInteraction<CondensedStep>(props, {
  onClick: (option, step) => emit('click', option, step),
  onChanged: (option, step) => emit('changed', option, step),
})
</script>
